import styled from 'styled-components';

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  & + & {
    margin-top: 24px;
  }
`;
